import { logAndNotifyError, logDebugSilently, logErrorSilently } from "./logger";
import { UserInfo } from "../types/user-info";
import notify from "devextreme/ui/notify";
import { API_URL, CLIENT_VERSION } from "../constants";

export const baseUrl = API_URL; //Flyttat till constants.ts för att kunna byta mellan dev och prod

let token = "";
let tokenValidUntil = new Date();
let jwt: UserInfo | undefined = undefined;

const tknKey = "QWTool.Auth";
const jwtInStorage = localStorage.getItem(tknKey);
if (jwtInStorage) {
  try {
    const ojwtInStorage = JSON.parse(jwtInStorage);
    token = ojwtInStorage.token;
    tokenValidUntil = new Date(ojwtInStorage.tokenValidUntil);
    jwt = ojwtInStorage.jwt;
  } finally {
  }
}

export function getUserInfo() {
  return jwt;
}

export function getAuthHeader() {
  if (token) return { Authorization: "Bearer " + token };
  else return null;
}

export function geValidUntil() {
  return tokenValidUntil;
}

export async function get<T = any>(url: string) {
  //console.log("GET:" + baseUrl + url);

  //eskil tycker vi ska typa den här!!
  const options: RequestInit = {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) (options.headers as any).Authorization = "Bearer " + token;

  const response = await fetch(baseUrl + url, options as any);

  if (response.status === 200) return response.json() as T;
  else if (response.status === 401) {
    //Unauthorized -> login
    token = "";
    tokenValidUntil = new Date();
    jwt = undefined;
    localStorage.removeItem(tknKey);

    PubSub.publish("LoggedOut");
    setTimeout(() => {
      (document as any).location.href = (document as any).location.origin + "/login";
    }, 1000);
  } else {
    const text = await response.text();

    logAndNotifyError(`Error when GET to ${url} : ${response.status} - ${text}`);
    throw new Error(`Error when POST to ${url} : ${response.status} - ${text}`);
  }
}

export async function deleteHttp<T = any>(url: string) {
  const options: RequestInit = {
    method: "DELETE", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) (options.headers as any).Authorization = "Bearer " + token;
  const response = await fetch(baseUrl + url, options as any);

  if (response.status === 200) return response.json() as T;
  else {
    const text = await response.text();

    logAndNotifyError(`Error when DELETE to ${url} : ${response.status} - ${text}`);
    throw new Error(`Error when DELETE to ${url} : ${response.status} - ${text}`);
  }
}

export async function post(url: string, data: object) {
  const options = {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  };

  if (token) (options.headers as any).Authorization = "Bearer " + token;

  const response = await fetch(baseUrl + url, options as any);

  if (!response) {
    return undefined;
  }

  if (response.status === 200) return response.json();
  else if (response.status === 401) {
    //Unauthorized -> login

    if (jwt) {
      logAndNotifyError("Unauthorized to '" + url + "' - Logging out");
      token = "";
      tokenValidUntil = new Date();
      jwt = undefined;
      localStorage.removeItem(tknKey);

      PubSub.publish("LoggedOut");
      setTimeout(() => {
        (document as any).location.href = (document as any).location.origin + "/login";
      }, 1000);

      const dbg = 5;
    }
  } else {
    const text = await response.text();

    logAndNotifyError(`Error when POST to ${url} : ${response.status} - ${text}`);
    throw new Error(`Error when POST to ${url} : ${response.status} - ${text}`);
  }
}

function parseJwt(token: string) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  let ret = JSON.parse(jsonPayload);
  logDebugSilently(ret);
  ret.roles = ret["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  ret.userName = ret["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];

  if (ret.roles && !Array.isArray(ret.roles)) ret.roles = [ret.roles];

  //ret.roles = { ...ret.roles }; //Transform to object for easy checking
  if (!ret.roles) ret.roles = [];
  ret.roles = ret.roles.reduce((ack: any, cur: string) => {
    ack[cur] = true;
    return ack;
  }, {});

  return ret;
}
let isOnline: boolean | undefined = undefined;
async function checkLoggedIn() {
  try {
    if (!token) return;
    var result = await post("api/Authenticate/checkLoggedIn", {});

    var dbg = result;
    if (isOnline === false) {
      notify("Online", "success");
      PubSub.publish("Online", { isOnline: true });
    }
    isOnline = true;
    if (result?.status === "Refresh") {
      if (tmrCheckLogin) clearInterval(tmrCheckLogin);

      var dbg2 = result;
      token = result.token;
      const currentStorage = localStorage.getItem(tknKey);
      const current = currentStorage ? JSON.parse(currentStorage).jwt : {};
      tokenValidUntil = new Date(result.expiration);
      jwt = { ...current, ...parseJwt(token), ...result.userInfo } as UserInfo;
      localStorage.setItem(tknKey, JSON.stringify({ token, tokenValidUntil, jwt }));
      // result.userInfo = jwt;
      tmrCheckLogin = setInterval(checkLoggedIn, 20000);
    }
    if (result?.clientVersion && result.clientVersion !== CLIENT_VERSION) {
      notify("Ny version av QWTool finns tillgänglig, sidan kommer att laddas om!", "warning");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  } catch (err) {
    logDebugSilently("checkLoggedIn error, isonline:" + isOnline);
    logDebugSilently(err);
    var dbgE = "X";
    if (isOnline === true || isOnline === undefined) {
      notify("Offline", "error");
      PubSub.publish("Online", { isOnline: false });
    }
    isOnline = false;
  }
}

let tmrCheckLogin: NodeJS.Timer | undefined = undefined;
export async function login(userName: string, password: string) {
  try {
    var result = await post("api/Authenticate/login", {
      username: userName,
      password: password,
    });

    if (!result.status) {
      token = result.token;
      tokenValidUntil = new Date(result.expiration);
      jwt = { ...parseJwt(token), ...result.userInfo } as UserInfo;
      localStorage.setItem(tknKey, JSON.stringify({ token, tokenValidUntil, jwt }));
      result.userInfo = jwt;
      isOnline = true;
      PubSub.publish("LoggedIn", result.userInfo);
    }

    if (tmrCheckLogin) clearInterval(tmrCheckLogin);
    tmrCheckLogin = setInterval(checkLoggedIn, 20000);

    return result;
  } catch (err: any) {
    notify("Kunde inte logga in, verifiera email och lösenord ", "error");
    throw err;
  }
}

export async function switchCustomer(companyId: number) {
  try {
    var result = await post("Admin/SwitchCustomer/" + companyId, {});
    var dbg = result;
    window.location.href = "../Buildings"; //Make a hard reload and navigate to buildings
  } catch (err: any) {
    notify("Kunde inte byta kund: " + (err.message ? err.message : err), "error");
    throw err;
  }
}

export async function switchAccount(accountId: string) {
  try {
    var result = await post("api/Authenticate/ChangeAccount/" + accountId, {});

    if (!result.status) {
      token = result.token;
      tokenValidUntil = new Date(result.expiration);
      jwt = { ...parseJwt(token), ...result.userInfo } as UserInfo;
      localStorage.setItem(tknKey, JSON.stringify({ token, tokenValidUntil, jwt }));
      result.userInfo = jwt;
      isOnline = true;
      PubSub.publish("LoggedIn", result.userInfo);
    }

    if (tmrCheckLogin) clearInterval(tmrCheckLogin);
    tmrCheckLogin = setInterval(checkLoggedIn, 20000);

    window.location.href = "../Buildings"; //Make a hard reload and navigate to buildings
  } catch (err: any) {
    notify("Kunde inte byta konto: " + (err.message ? err.message : err), "error");
    throw err;
  }
}

export async function logout() {
  try {
    notify("Logging out");
    if (tmrCheckLogin) {
      clearInterval(tmrCheckLogin);
    }
    await post("api/Authenticate/logout", {});
  } catch (err: any) {
    //notify("Kunde inte logga ut: " + (err.message ? err.message : err), "error");
  }

  token = "";
  tokenValidUntil = new Date();
  jwt = undefined;
  localStorage.removeItem(tknKey);

  PubSub.publish("LoggedOut");
}

export async function updateUserInfo(userInfo: UserInfo) {
  try {
    const jwtInStorage = localStorage.getItem(tknKey);

    if (jwtInStorage) {
      const ojwtInStorage = JSON.parse(jwtInStorage);
      const dbg = jwt;
      jwt = { ...ojwtInStorage.jwt, ...userInfo } as UserInfo;
      ojwtInStorage.jwt = jwt;
      localStorage.setItem(tknKey, JSON.stringify(ojwtInStorage));
    }

    PubSub.publish("LoggedIn", jwt);
  } catch (err) {}
}

if (tokenValidUntil) {
  //Currently logged in after a page refresh...
  if (tmrCheckLogin) clearInterval(tmrCheckLogin);
  tmrCheckLogin = setInterval(checkLoggedIn, 20000);
}
const dflt = {
  login,
  logout,
  switchAccount,
};

export default dflt;
